export const PUBLIC_TEST_ENDPOINTS = ["/verify", "/represent"] as const;
export const DASHBOARD_TEST_ENDPOINTS = [
  "/verify",
  "/represent",
  "/compare",
] as const;

export type PublicTestEndpoint = (typeof PUBLIC_TEST_ENDPOINTS)[number];
export type DashboardTestEndpoint = (typeof DASHBOARD_TEST_ENDPOINTS)[number];
export type TesterEndpoint = DashboardTestEndpoint;

export function isTesterEndpoint(value: string): value is TesterEndpoint {
  return (DASHBOARD_TEST_ENDPOINTS as readonly string[]).includes(value);
}

export function isPublicTestEndpoint(value: string): value is PublicTestEndpoint {
  return (PUBLIC_TEST_ENDPOINTS as readonly string[]).includes(value);
}

export const ENDPOINT_DESCRIPTIONS: Record<DashboardTestEndpoint, string> = {
  "/verify": "Check whether two photos show the same person.",
  "/represent": "Turn a face photo into numbers (an embedding) you can compare later.",
  "/compare": "Compare a photo or embedding with saved embeddings to check for a match.",
};
